var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// TODO: Make poss with unique id
import { useLocation, useSearchParams } from 'react-router-dom';
export var useFormPersistence = function (id) {
    var location = useLocation();
    var _a = useSearchParams(), setSearchParams = _a[1];
    var params = new URLSearchParams(location.search);
    var load = function (fields, setFields) {
        return Object.keys(fields).reduce(function (prev, keyString) {
            var _a, _b;
            var key = keyString;
            var field = fields[key];
            if (!field.persistURL && !field.persistStore)
                return __assign(__assign({}, prev), (_a = {}, _a[key] = fields[key].initialValue, _a));
            var paramValue = params.get(keyString);
            if (paramValue) {
                setFields(function (prev) {
                    var newFields = __assign({}, prev);
                    prev[key].touched = true;
                    return newFields;
                });
            }
            var value = paramValue
                ? field.valueConverter.convertToValue(paramValue)
                : field.initialValue;
            return __assign(__assign({}, prev), (_b = {}, _b[key] = value, _b));
        }, {});
    };
    var persist = function (form, values) {
        var params = new URLSearchParams();
        form.keys.forEach(function (key) {
            var field = form.fields[key];
            if (!field.persistURL && !field.persistStore)
                return;
            if (!field.touched || form.fields[key].resetValue === values[key])
                return;
            params.append(String(key), field.valueConverter.convertToString(values[key]));
        });
        var paramString = params.keys.length
            ? "?".concat(params.toString())
            : '';
        window.history.replaceState(null, paramString);
    };
    return { load: load, persist: persist };
};
export default useFormPersistence;
